// Add your custom JS here.

import $ from 'jquery';




$(document).ready(function(){

	// Sliders
	var $slider = $('.product-slider');

    if ($slider.length) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            fade: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 500,
            cssEase: 'linear'
        });
    }

	$('.navbar-toggler').click(function(){
		$(this).toggleClass('open');
	});

    $( '.sub-menu-toggle' ).on( 'click', function() {
        $(this).toggleClass( 'show' );
        $(this).parent().find('.dropdown-menu').first().slideToggle();
    })
});
